import { render, staticRenderFns } from "./ClassActivities.vue?vue&type=template&id=a55a4a9a&scoped=true&"
import script from "./ClassActivities.vue?vue&type=script&lang=js&"
export * from "./ClassActivities.vue?vue&type=script&lang=js&"
import style0 from "./ClassActivities.vue?vue&type=style&index=0&id=a55a4a9a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55a4a9a",
  null
  
)

export default component.exports